// import img1 from "../assets/images/sliders/classic/arab_workspace.avif";
// import img2 from "../assets/images/sliders/classic/international.avif"; //arab_red_ring.avif
// import img3 from "../assets/images/sliders/classic/coding.avif";
// import img4 from "../assets/images/sliders/classic/s-ivisita.avif";

import {Icons} from "./svgIcons";

const homePageData = {
  process: {
    title: "Our Development Process",
    steps: [
      { num: "01", translateKey: "discovery", translateDesc: "weAnalyze" },
      { num: "02", translateKey: "design", translateDesc: "uiuxWireframes" },
      { num: "03", translateKey: "development", translateDesc: "agileSprints" },
      { num: "04", translateKey: "delivery", translateDesc: "testingDeployment" }
    ]
  },
  services: {
    title: "Our Services",
    subtitle: "End-to-end software development solutions to your business needs",
    web: {
      title: "Web Application Development",
      short: "Web Applications",
      desc: "Scalable, high-performance web applications built with cutting-edge technologies. From SPAs to enterprise portals, we deliver exceptional digital experiences.",
      features: ["React / Vue / Angular", "Node.js & Cloud APIs", "E-commerce Platforms", "Enterprise Portals", "Progressive Web Apps"]
    },
    mobile: {
      title: "Mobile Application Development",
      short: "Mobile Applications",
      desc: "Native and cross-platform mobile apps for iOS and Android that users love. Seamless UX with powerful backend integrations.",
      features: ["iOS & Android", "React Native / Flutter", "UI/UX Design", "App Store Deployment", "Push Notifications"]
    },
    desktop: {
      title: "Desktop Application Development",
      short: "Desktop Applications",
      desc: "Powerful desktop solutions for Windows, macOS, and Linux. High-performance applications for demanding business workflows.",
      features: ["Windows / macOS / Linux", "Electron & .NET", "Offline Capability", "System Integration", "Auto-updates"]
    },
    custom: {
      title: "Customized Software Solutions",
      short: "Custom Software",
      desc: "Bespoke software engineered precisely to your business requirements. ERP, CRM, and custom workflows that scale with your growth.",
      features: ["ERP & CRM Systems", "Business Automation", "Legacy Modernization", "API Integrations", "Data Analytics"]
    }
  },
}

const serviceCards = [
  {
    key: 'web',
    url: "/services/web-application-development",
    icon: <Icons.Globe />, href: '/services/web',
    img: 'https://images.unsplash.com/photo-1547658719-da2b51169166?w=600&q=80',
    color: 'from-blue-500 to-indigo-600',
    title: "webApplicationDevelopment",
    short: "webApplications",
    desc: "scalableWebApp",
    // features: "reactVueWeApp",
    features: ["React / Vue / Angular", "Node.js & Cloud APIs", "E-commerce Platforms", "Enterprise Portals", "Progressive Web Apps"],
  },
  {
    key: 'mobile',
    url: "/services/mobile-development",
    icon: <Icons.Mobile />, href: '/services/mobile',
    img: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=600&q=80',
    color: 'from-purple-500 to-pink-600',
    title: "mobileApplicationDevelopment",
    short: "mobileApp",
    desc: "nativeCross",
    features: ["iOS & Android", "React Native / Flutter", "UI/UX Design", "App Store Deployment", "Push Notifications"]
  },
  {
    key: 'desktop',
    url: "/services/erp-solutions",
    icon: <Icons.Monitor />, href: '/services/desktop',
    img: 'https://images.unsplash.com/photo-1593642632559-0c6d3fc62b89?w=600&q=80',
    color: 'from-cyan-500 to-blue-600',
    title: "desktopApplicationDevelopment",
    short: "desktopApplication",
    desc: "powerfulDesktop",
    features: ["Windows / macOS / Linux", "Electron & .NET", "Offline Capability", "System Integration", "Auto-updates"]
  },
  {
    key: 'custom',
    url: "/services/customized-software",
    icon: <Icons.Settings />, href: '/services/custom',
    img: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&q=80',
    color: 'from-orange-500 to-red-600',
    title: "customizedSoftwareSolutions",
    short: "customizedSoftware",
    desc: "bespokeSoftware",
    features: ["ERP & CRM Systems", "Business Automation", "Legacy Modernization", "API Integrations", "Data Analytics"]
  },
];

const whyChoose = [
    { title: "gccExpertise", desc: "deepUnderstanding" },
    { title: "agileDelivery", desc: "rapidIteration" },
    { title: "24Support", desc: "RoundThe" },
    { title: "globalStandard", desc: "internationalCoding" }
]

export {
  homePageData,
  serviceCards,
  whyChoose
}
